import { render, staticRenderFns } from "./RecruiterCompanyLocation.vue?vue&type=template&id=5ec421ff&scoped=true&"
import script from "./RecruiterCompanyLocation.vue?vue&type=script&lang=ts&"
export * from "./RecruiterCompanyLocation.vue?vue&type=script&lang=ts&"
import style0 from "./RecruiterCompanyLocation.vue?vue&type=style&index=0&id=5ec421ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec421ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
